import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en/en.json';
import ru from './ru/ru.json';
import kk from './kk/kk.json';
import errors from './en/errors.json';
import errorsRu from './ru/errors.json';
import errorsKk from './kk/errors.json';
import prescription from './en/prescription/prescription.json';
import editDevice from './en/device/edit-device.json';
import createDevice from './en/device/create-device.json';
import deviceDir from './en/device/device-dir.json';
import deviceDetails from './en/device/device-details.json';
import medDir from './en/med/med.json';
import createUser from './en/users/create-user.json';
import users from './en/users/users.json';
import orders from './en/orders/orders.json';
import activity from './en/activity/activity.json';
import statuses from './en/statuses/statuses.json';
import prescriptionRu from './ru/prescription/prescription.json';
import editDeviceRu from './ru/device/edit-device.json';
import createDeviceRu from './ru/device/create-device.json';
import deviceDirRu from './ru/device/device-dir.json';
import medDirRu from './ru/med/med.json';
import createUserRu from './ru/users/create-user.json';
import usersRu from './ru/users/users.json';
import ordersRu from './ru/orders/orders.json';
import deviceDetailsRu from './ru/device/device-details.json';
import activityRu from './ru/activity/activity.json';
import statusesRu from './ru/statuses/statuses.json';
import prescriptionKk from './kk/prescription/prescription.json';
import editDeviceKk from './kk/device/edit-device.json';
import createDeviceKk from './kk/device/create-device.json';
import deviceDirKk from './kk/device/device-dir.json';
import medDirKk from './kk/med/med.json';
import createUserKk from './kk/users/create-user.json';
import usersKk from './kk/users/users.json';
import ordersKk from './kk/orders/orders.json';
import deviceDetailsKk from './kk/device/device-details.json';
import activityKk from './kk/activity/activity.json';
import statusesKk from './kk/statuses/statuses.json';


const savedLanguage = localStorage.getItem('language') || 'en';

const resources = {
  en: {
    translation: {
      ...en,
      "errors": errors,
      "users": users,
      "create-user": createUser,
      "med-directory": medDir,
      "device-directory": deviceDir,
      "device-details": deviceDetails,
      "create-device": createDevice,
      "edit-device": editDevice,
      "prescription-directory": prescription,
      "orders-directory": orders,
      "activity-directory": activity,
      "statuses":statuses
    },
  },
  ru: {
    translation: {
      ...ru,
      "errors": errorsRu,
      "users": usersRu,
      "create-user": createUserRu,
      "med-directory": medDirRu,
      "device-directory": deviceDirRu,
      "device-details": deviceDetailsRu,
      "create-device": createDeviceRu,
      "edit-device": editDeviceRu,
      "prescription-directory": prescriptionRu,
      "orders-directory": ordersRu,
      "activity-directory": activityRu,
      "statuses":statusesRu
    },
  },
  kk: {
    translation: {
      ...kk,
      "errors": errorsKk,
      "users": usersKk,
      "create-user": createUserKk,
      "med-directory": medDirKk,
      "device-directory": deviceDirKk,
      "device-details": deviceDetailsKk,
      "create-device": createDeviceKk,
      "edit-device": editDeviceKk,
      "prescription-directory": prescriptionKk,
      "orders-directory": ordersKk,
      "activity-directory": activityKk,
      "statuses":statusesKk
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: savedLanguage,
  fallbackLng: savedLanguage,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
